import classNames from 'classnames';
import { Button } from 'components-antd';

import styles from './styles.module.scss';

import { dynamicManager } from '../../DynamicManager';
import { SignViewOptionsPopover } from './components/SignViewOptionsPopover';

import { InfoTooltip } from '../../Containers/DynamicEditor/components/InfoTooltip';
import { useManageQuestions } from './hooks/useManageQuestions';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';
import { useRef, useState } from 'react';
import { useOutsideClick } from 'hooks';

export const SignViewButtons = (props) => {
  const { showDecline, isProcessing, onContinue } = props;
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLInputElement>(null);

  const { totalQuestions, totalRequiredQuestions, filledRequiredQuestions, filledQuestions } =
    useManageQuestions();

  useOutsideClick([buttonRef], () => setOpen(false));

  const onCloseForm = () => {
    dynamicManager.handleFormExit();
  };

  const getText = () => {
    if (
      !totalRequiredQuestions ||
      (totalRequiredQuestions && totalRequiredQuestions === filledRequiredQuestions)
    )
      return '';

    const options = [
      {
        label: `${filledQuestions}/${totalQuestions} fields complete`,
        variant: ICON_VARIANT_TYPE.CheckCircle,
        stroke: filledQuestions === totalQuestions ? '#219653' : null,
      },
      {
        label: `${filledRequiredQuestions}/${totalRequiredQuestions} required fields complete`,
        variant: ICON_VARIANT_TYPE.ExclaimationCircle,
      },
    ];

    return (
      <div className={styles.questionsTooltipContainer}>
        {options.map((item) => {
          return (
            <div key={item.variant} className={styles.tooltipItem}>
              <Icons variant={item.variant} stroke={item.stroke || ''} />
              <div className={styles.tooltipLabel}>{item.label}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const isDisabled = props.isDisabled || filledRequiredQuestions < totalRequiredQuestions;

  const toggleButton = () => {
    setOpen(!open);
  };

  return (
    <div className={styles.signViewButtonsWrapper}>
      <InfoTooltip
        trigger="click"
        text={getText()}
        autoClose={false}
        tooltipOpen={open}
        closeOnMouseLeave={false}
        className={styles.buttonTooltip}
        overlayClassName={styles.signButtonOverlay}
        closeOnOutsideClick
      >
        <div ref={buttonRef} onClick={isDisabled ? toggleButton : undefined}>
          <Button
            variant="secondary"
            className={classNames(styles.signButton, {
              [styles.disabledButton]: isDisabled,
            })}
            disabled={props.isDisabled}
            onClick={isDisabled || isProcessing ? undefined : onContinue}
            loading={isProcessing}
          >
            Finish
          </Button>
        </div>
      </InfoTooltip>

      <SignViewOptionsPopover showDecline={showDecline} onCloseForm={onCloseForm} />
    </div>
  );
};
